import { render, staticRenderFns } from "./TemplatePlaceholderList.vue?vue&type=template&id=dfee3142&scoped=true&"
import script from "./TemplatePlaceholderList.vue?vue&type=script&lang=js&"
export * from "./TemplatePlaceholderList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfee3142",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
installComponents(component, {VAlert})
